import React, { useContext, useEffect, useState } from 'react'
import { CButton, CNav, CNavItem, CNavLink, CRow, CTabContent, CTabPane } from '@coreui/react'
import TemplateSelection from './templateSelection'
import ComponentSelection from './componentSelection'
import { ACCOUNT_API, BASE_COMPONENTS, BASE_TEMPLATE } from 'src/views/utils/urls'
import useAxios from 'axios-hooks'
import { AppContext } from 'src/views/context/app'
import { useHistory, useLocation } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { raiseToast } from 'src/views/utils/helper'

const ManageTemplates = () => {
  const history = useHistory()
  const location = useLocation()
  const { setLoader } = useContext(AppContext)
  const [activePane, setActivePane] = useState(1)
  const [accountData, setAccountData] = useState({})
  const [allowedTemplates, setAllowedTemplates] = useState([])
  const [allowedComponents, setAllowedComponents] = useState([])

  const [{ data: baseTemplateList, loading: baseTemplateListLoading }] = useAxios({
    url: BASE_TEMPLATE,
    method: 'get',
  })

  const [{ data: baseComponentList, loading: baseComponentLoading }] = useAxios({
    url: BASE_COMPONENTS,
    method: 'get',
  })

  const [{ data: updateAdminUser, loading: updateAdminUserLoading }, adminUserUpdateCall] =
    useAxios(
      {
        url: ACCOUNT_API,
        method: 'put',
      },
      { manual: true },
    )

  useEffect(() => {
    setLoader(baseTemplateListLoading || baseComponentLoading || updateAdminUserLoading)
  }, [baseTemplateListLoading, baseComponentLoading, updateAdminUserLoading])

  useEffect(() => {
    if (updateAdminUser && updateAdminUser.success) {
      raiseToast('success', 'updated successfully!')
    }
  }, [updateAdminUser])

  useEffect(() => {
    if (!isEmpty(location.state)) {
      setAccountData(location.state)
      setAllowedComponents(
        location.state?.allowed_components ? location.state?.allowed_components : [],
      )
      setAllowedTemplates(
        location.state?.allowed_templates ? location.state?.allowed_templates : [],
      )
    } else {
      history.push({ pathname: '/manage-accounts' })
    }
  }, [])

  const handleSave = () => {
    if (!location.state?._id) {
      return
    }
    let payload = {
      ...accountData,
      allowed_templates: allowedTemplates,
      allowed_components: allowedComponents,
    }
    delete payload['_id']
    adminUserUpdateCall({
      params: {
        account_id: location.state._id,
      },
      data: payload,
    })
  }

  const activeTab = { color: '#1976d2', fontSize: '1.1rem' }
  const inActiveTab = { color: '#191818', fontSize: '1.1rem' }
  return (
    <>
      <CRow className="mt-3">
        <CNav variant="tabs">
          <CNavItem>
            <CNavLink
              style={activePane === 1 ? activeTab : inActiveTab}
              className="px-5"
              active={activePane === 1}
              onClick={() => setActivePane(1)}
            >
              Templates
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={activePane === 2 ? activeTab : inActiveTab}
              className="px-5"
              active={activePane === 2}
              onClick={() => setActivePane(2)}
            >
              Components
            </CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent className=" px-0">
          <CTabPane role="tabpanel" visible={activePane === 1} className="">
            <TemplateSelection
              baseTemplateData={baseTemplateList?.data || []}
              allowedTemplates={allowedTemplates}
              setAllowedTemplates={setAllowedTemplates}
            />
          </CTabPane>
          <CTabPane role="tabpanel" visible={activePane === 2}>
            <ComponentSelection
              data={baseComponentList?.data || []}
              allowedComponents={allowedComponents}
              setAllowedComponents={setAllowedComponents}
            />
          </CTabPane>
        </CTabContent>
      </CRow>
      <div className="mt-3 d-flex justify-content-end">
        <CButton
          style={{ color: 'black', border: '1px solid black' }}
          className="mx-4 px-3 bg-white rounded-1 btn-focus-none"
          onClick={() => {
            history.push({ pathname: '/manage-accounts' })
          }}
        >
          Back
        </CButton>
        <CButton className="px-3 bg-black rounded-1 btn-focus-none" onClick={handleSave}>
          Save
        </CButton>
      </div>
    </>
  )
}

export default ManageTemplates
